namespace advisorop.components.servicer {
    
    export class CuOfficeRangeController{

        custodianAdvisoryFirmId: number;
        officeRange: domains.ICustodianAdvisoryFirmOfficeRange;

        onOfficeRangeCreated: any;
        onOfficeRangeCanceled: any;
        onOfficeRangeModified: any;
        onOfficeRangeDeleted: any;
        
        constructor(private servicerService: services.ServicerService) {           
        }

        createNew() {

            this.officeRange.custodianAdvisoryFirmId = this.custodianAdvisoryFirmId;

            this.servicerService.createOfficeRange(this.officeRange)
                .then(data => {
                    this.officeRange = data.data;

                    //emit created new event
                    this.onOfficeRangeCreated({ officeRange: this.officeRange });
                })
                .catch(data => {
                    toastr.error("Error " + data.status + " " + data.data);
                });
        };

        saveChanges() {

            //this.officeRange.custodianCompanyGroupId = this.custodianCompanyGroupId;

            this.servicerService.updateOfficeRange(this.officeRange)
                .then(data => {
                    this.officeRange = data.data;

                    //emit save changes event
                    this.onOfficeRangeModified({ officeRange: this.officeRange });
                })
                .catch(data => {
                    toastr.error("Error " + data.status + " " + data.data);
                });
            
        };

        cancel() {
            //emit cancel event
            this.onOfficeRangeCanceled({ officeRange: this.officeRange });
        };
        
        $onInit(): void {                       
        }

        $onChanging(evt) {
        }
      

    }



    class CuOfficeRange implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                custodianAdvisoryFirmId: "<",
                officeRange: "<",
                onOfficeRangeCreated: "&",
                onOfficeRangeCanceled: "&",
                onOfficeRangeModified: "&",
                onOfficeRangeDeleted: "&"
            };
            this.controller = ["servicerService", CuOfficeRangeController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/cu-office-range.html';            
        }
    }
    angular.module(Constants.APP).component("cuOfficeRange", new CuOfficeRange());
    
}